var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",class:_vm.color},[_c('b-spinner'),_c('div',{staticClass:"mt-1"},[_vm._v(" "+_vm._s(_vm.loadingText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }